import { initBTCCurve } from "@babylonlabs-io/btc-staking-ts";
import { useEffect } from "react";

import { Container } from "./components/Container/Container";
import { Activity } from "./components/Delegations/Activity";
import { MultistakingFormWrapper } from "./components/Multistaking/MultistakingForm/MultistakingFormWrapper";
import { PersonalBalance } from "./components/PersonalBalance/PersonalBalance";
import { Stats } from "./components/Stats/Stats";
import Layout from "./layout";

const Home = () => {
  useEffect(() => {
    initBTCCurve();
  }, []);

  return (
    <Layout>
      <Container
        as="main"
        className="-mt-[10rem] md:-mt-[6.5rem] flex flex-col gap-12 md:gap-16 pb-16"
      >
        <Stats />
        <PersonalBalance />
        <MultistakingFormWrapper />
        <Activity />
      </Container>
    </Layout>
  );
};

export default Home;
